import { render, staticRenderFns } from "./FacDashboardComponent.vue?vue&type=template&id=0fb5ce4c"
import script from "./FacDashboardComponent.vue?vue&type=script&lang=js"
export * from "./FacDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports